export interface IBuildSorterProps {
  sortName?: string | null;
  sortOrder?: string | null;
}

export const ORDER_DIRECTION_OPTIONS = [
  { label: 'Ascending', value: 'asc' },
  { label: 'Descending', value: 'desc' },
];

const SORT_ORDER_MAP: Record<string, string> = {
  ascend: 'asc',
  descend: 'desc',
};

export const buildSorter = ({
  sortName,
  sortOrder,
}: IBuildSorterProps): string | undefined => {
  if (!sortName || !sortOrder) return undefined;

  const order = SORT_ORDER_MAP[sortOrder] || sortOrder;

  return `${sortName},${order}`;
};
